<template>
    <v-col cols="12">
        <!-- deleted             :focus="menu2" from v-textfield -->
        <v-text-field
            v-model="enteredTime"
            :active="menu2"

            :label="label"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="props" >
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                activator="parent"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >  
                <v-time-picker
                    v-if="menu2"
                    v-model="enteredTime"
                    :label="label"
                    format="24hr"
                ></v-time-picker>
            </v-menu>
         </v-text-field>
      </v-col>  
</template>


<script setup>
import { ref, watch } from 'vue';


const props = defineProps(['passedtime']);
const enteredTime = ref(props.passedtime.enteredTime); 
const label = ref(props.passedtime.label);
const emit = defineEmits(['timeentered']);
const menu2 = ref(false)


watch(() => enteredTime.value, (newValue) => {
  if (newValue) {
    emit('timeentered', newValue);
  }
});
</script>